module.exports = __webpack_public_path__ + "img/partner_lg_02@2x.1920a6cc.png";